import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { FeedbackPromptBar } from './FeedbackPromptBar';
export const GetInviteMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const InviteMessage = (param)=>{
    let { content, messageId, onSubmitFeedback, onDismissFeedback } = param;
    const { InviteMessageTID } = useMemo(()=>GetInviteMessageTID(messageId), [
        messageId
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": InviteMessageTID.Root(),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                testId: InviteMessageTID.Intro(),
                showWhiteSpaces: true,
                applyMarkdownBold: true,
                children: content.intro
            }),
            content.feedbackPrompt != null && onSubmitFeedback != null && onDismissFeedback != null && /*#__PURE__*/ _jsx(FeedbackPromptBar, {
                prompt: content.feedbackPrompt,
                onSubmit: onSubmitFeedback,
                onDismiss: onDismissFeedback,
                testId: messageId
            })
        ]
    });
};
